import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../../web/validation";
import {Entity} from "../entity";

export const ServiceTypeFacetModeCodec = t.intersection([
  t.type({
    id: t.string,
    companyId: t.string,
    serviceTypeId: t.string,
    facet: t.string,
    mode: t.string,
    primary: t.boolean,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
  t.partial({
    createdById: t.string,
    lastModifiedById: t.string,
  }),
]);

export type ServiceTypeFacetMode = t.TypeOf<typeof ServiceTypeFacetModeCodec>;

@Exclude()
export class ServiceTypeFacetModeEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  companyId!: string;

  @Expose()
  serviceTypeId!: string;

  @Expose()
  facet!: string;

  @Expose()
  mode!: string;

  @Expose()
  primary!: boolean;

  @Expose()
  createdById?: string;

  @Expose()
  lastModifiedById?: string;

  @Expose()
  createDttm!: number;

  @Expose()
  lastModifiedDttm!: number;

  readonly entityType = 'SERVICETYPEFACETMODE';

  get displayName(): Readonly<string> {
    return this.id;
  }

  /**
   * Constructor for ServiceTypeFacetModeEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: ServiceTypeFacetMode): ServiceTypeFacetModeEntity {
    return plainToInstance(ServiceTypeFacetModeEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<ServiceTypeFacetMode> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(ServiceTypeFacetModeCodec, object);
  }

  asTypeValue(): ServiceTypeFacetMode {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(ServiceTypeFacetModeCodec, object);
  }
}

export type ServiceTypeFacetModeSaveDTO = {
  companyId: string,
  serviceTypeId: string,
  facetCode: string
  modeCode: string;
  primary: boolean
}
